module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    attrs: {
      "id": "exp"
    }
  }, [_vm._v("\n        Block difficulty.\n    ")]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n        The BCH chain is currently running at\n        "), _c('strong', [_vm._v(_vm._s(_vm.sprintf('%.2f', _vm.data.BCH.averages.last.avg_diff / _vm.data.BTC.averages.last.avg_diff * 100)) + "%")]), _vm._v(" difficulty compared to the BTC chain.\n    ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('expected')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "512px",
      "width": "100%"
    }
  }, [_c('canvas', {
    staticStyle: {
      "height": "512px"
    },
    attrs: {
      "id": "canvas-difficulty"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2be21454","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/charts/difficulty.vue
// module id = 536
// module chunks = 1